module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAACCAYAAABIZrJXAAAAHUlEQVQokWP8//+/AMMoGFAAioT/o1EwgICBgQEAS7gHDCLBv6oAAAAASUVORK5CYII="